
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class GridContainer extends Vue {
  @Prop({ default: "none" }) private flow: "none" | "column";
}
